import { Injectable } from '@angular/core';
import { urls } from '../../environments/environment';
import { HttpService } from './http.service';
import { Subject } from 'rxjs';
import { ActionsService } from './ActionService.service';

@Injectable({ providedIn: 'root' })
export class PollsService {


	constructor(private http: HttpService, public global: ActionsService) { }

	

    viewPoll(data, load) {
		
		
		return new Promise((resolve, reject) => {
			this.http.get(urls.poll + '?token='+this.global.token()+'& start='+data.start +'& limit='+data.limit+'& search='+data.search, load)
				.then(async (res: any) => {
					resolve(res);
				}, error => {
					reject({ message: error.message, error })
				})
		})
		
	}
    detailPoll(id) {

		
		return new Promise((resolve, reject) => {
			this.http.get(urls.poll +'/'+id+ '?token='+this.global.token(), "Cargando...")
				.then(async (res: any) => {
					resolve(res);
				}, error => {
					reject({ message: error.message, error })
				})
		})
		
	}
	RellenoPoll(id) {
		
		return new Promise((resolve, reject) => {
			this.http.get(urls.poll +'/answers/'+id+ '?token='+this.global.token(), "Cargando...")
				.then(async (res: any) => {
					resolve(res);
				}, error => {
					reject({ message: error.message, error })
				})
		})
		
	}
    PollStore(data) {
	
		return new Promise((resolve, reject) => {
			this.http.post(urls.poll+'/store'+ '?token='+this.global.token(), true, data, "Guardando..")
				.then(async (res: any) => {
					resolve(res);
				
				}, error => {
					reject({ message: error.message, error })
				})
		})
		
	}
	


	

}
